import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { HeaderLogoImageComponent } from '../header-logo/header-logo-image.component';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
  selector: 'mwe-wizard-header',
  templateUrl: './wizard-header.component.html',
  imports: [HeaderLogoImageComponent, TranslatePipe, TranslateDirective, ButtonComponent],
})
export class WizardHeaderComponent {
  @Input() titleKey: string;
  @Input() isClosingAllowed = true;
  @Output() cancelEvent = new EventEmitter<any>();

  cancelOnHeader(): void {
    if (this.isClosingAllowed) {
      this.cancelEvent.emit();
    }
  }
}
